import React, { Component, useEffect, useState, useMemo } from 'react';

import mergeClassesOriginal from './shallowMerge';
import getDisplayName from '@magento/venia-ui/lib/util/getDisplayName';

const classify = defaultClasses => WrappedComponent =>
    class extends Component {
        static displayName = `Classify(${getDisplayName(WrappedComponent)})`;

        render() {
            const { className, classes, ...restProps } = this.props;
            const classNameAsObject = className ? { root: className } : null;
            const finalClasses = mergeClasses(
                defaultClasses,
                classNameAsObject,
                classes
            );

            return <WrappedComponent {...restProps} classes={finalClasses} />;
        }
    };

const mergeClasses = (...args) => {
    return mergeClassesOriginal(...args, globalThis.customClasses);

    const [customClasses, setImportClasses] = useState(window.customClasses);

    const classes = useMemo(() => {
        return mergeClassesOriginal(...args, customClasses);
    }, [...args, customClasses]);

    useEffect(() => {
        if (globalThis.customCssLoaded || globalThis.customCssLoading) {
            return;
        }

        globalThis.customCssLoading = true;

        console.log(
            'Loading custom css classes from: ' +
                `../../customs/${STORE_CUSTOM_CSS_FOLDER}/${STORE_VIEW_CODE}.module.css`
        );
        // important: argument to import() must be a fixed string, it cannot be
        // conditional, neither eval, neither the return of a function, ONLY fixed string
        import(`../../customs/${STORE_CUSTOM_CSS_FOLDER}/${STORE_VIEW_CODE}.module.css`)
            .then(data => {
                setImportClasses(data.default);
                console.log('custom css classes loaded', data.default);
                window.customClasses = data.default;
                delete globalThis.customCssLoading;
                globalThis.customCssLoaded = true;
            })
            .catch(error => console.error(error));
    }, [globalThis]);

    return classes;
};

export { mergeClasses, mergeClasses as useStyle };

export default classify;
